import * as Sentry from '@sentry/react'

export const captureError = <E extends Error>(error: E) => {
  Sentry.captureException(error)
}
